
import React, { useState } from "react";
import HeaderOne from "../components/HeaderOne";

import KarpagamAbout from "../components/Karpagamabout";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import AboutBanner from "../components/AboutBanner";
import Preloader from "../helper/Preloader";




import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";

const About = () => {
  const [cart, setCart] = useState([]);

  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#299E60" />

      {/* ColorInit */}
      <ColorInit color={false} />
      {/* ✅ HEADER ADDED */}
      <HeaderOne />
      <AboutBanner/>

    
      <div style={{ fontFamily: "'Lato', sans-serif", background: "#fdf6ee", color: "#5c2d0e" }}>

       
         <KarpagamAbout/>

      </div>

      {/* ✅ FOOTER ADDED */}
      <FooterOne/>
      <BottomFooter/>
    </>
  );
};

export default About;






 